/*******************************************************/
/**************** BYOB RELATED CODE ********************/
/*******************************************************/

function isBundle(data) {
  return data.vendor === "BYOB";
}

// checks if a product is island hopper
function isBag(data) {
  return data.id === 39577441960030;
}

(function(ns, fetch) {
    if (typeof fetch !== 'function') return;
  
    ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
            if ([
              `${window.location.origin}/cart/add.js`
            ].includes(res.url)) {
                res.clone().json().then(data => {
                  // if bundle product is added and no island hopper, automatically
                  // add island hopper product to the cart
                  if(data.items.filter(isBundle).length > 0 && Shopify.cartItems.filter(isBag).length === 0) {
                    var id=39577441960030;
                    $.ajax({
                      type: 'POST', 
                      url: '/cart/add.js',
                      dataType: 'json', 
                      data: {id:id,quantity:1},
                    });          
                  }
                });
            }
        });
        return response;
    }
}(window, window.fetch))